export interface ExistingControl {
  _id?: string
  ExistingControlId?: string
  Label: string
  Description: string
  Perimetre: string
  NombreActifCouvert: number
  TauxCouverture: number
  ControlNature: string
  SecurityControlId: string
  status?: number
  erreur?: boolean
  message?: string
}

export type ExistingControlResponse = {
  existingControls: ExistingControl[]
  total: number
  totalPages: number
  currentPage?: number
  status?: number
  erreur?: boolean
  message?: string
}
export enum IncidentPerimeter {
  NETWORK = 'Réseau',
  SERVERS = 'Serveurs',
  INTERNAL_APPLICATIONS = 'Applications Internes',
  DMZ = 'DMZ',
  CLOUD_APPLICATIONS = 'Applications Cloud',
  PC = 'PC',
}
export type ExistingControlMaturity = {
  existingControlId: string
  label: string
  maturityRate: number
}

export type MaturityRateResponse = {
  erreur: boolean
  status: number
  message: string
  data?: ExistingControlMaturity[]
}
